import { invokeApi } from "../../bl_libs/invokeApi";

export const FaqsListing = async (data) => {
  const requestObj = {
    path: `api/faq/get_member_faq`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
